<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!generazioneInCorso"
  [dismissableMask]="!generazioneInCorso"
  [style]="{width: '800px', maxWidth: '95vw'}"
  styleClass="p-fluid genera-richieste-dialog"
  [showHeader]="false"
  (onHide)="onHide()">

  <div class="dialog-container">
    <!-- Header del dialog -->
    <div class="dialog-header">
      <div class="header-content">
        <span class="material-icons" style="font-size: 28px; margin-right: 8px;">dashboard</span>
        <h2>Genera Richieste per l'Anno {{ anno +1 }}</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        [disabled]="generazioneInCorso"
        (click)="onHide()">
      </button>
    </div>

    <!-- Contenuto principale -->
    <div class="dialog-content" *ngIf="!mostraConferma">
      <!-- Barra di filtro e info -->
      <div class="filter-bar">
        <div class="search-input-wrapper">
          <span class="p-input-icon-left p-input-icon-right">
            <i class="pi pi-search"></i>
            <input
              type="text"
              pInputText
              [(ngModel)]="filtroEnte"
              (input)="filtraEnti()"
              placeholder="Cerca ente esecutore..."
              class="search-input">
            <i *ngIf="filtroEnte" class="pi pi-times clear-icon" (click)="filtroEnte=''; filtraEnti()"></i>
          </span>
        </div>

        <div class="selection-info">
          <p-checkbox
            [(ngModel)]="selezionaTutti"
            [binary]="true"
            (onChange)="toggleSelezionaTutti()"
            inputId="selezionaTutti">
          </p-checkbox>
          <label for="selezionaTutti" class="ml-2">Seleziona tutti</label>

          <span class="selection-counter" *ngIf="entiSelezionati.length > 0">
            {{ entiSelezionati.length }} ent{{ entiSelezionati.length === 1 ? 'e' : 'i' }} selezionat{{ entiSelezionati.length === 1 ? 'o' : 'i' }}
          </span>
        </div>
      </div>

      <!-- Tabella di enti -->
      <div class="table-container">
        <!-- Loader durante il caricamento -->
        <div *ngIf="caricamentoInCorso" class="loading-overlay">
          <div class="loading-content">
            <p-progressBar [value]="progressoCaricamento" [showValue]="false"></p-progressBar>
            <span class="loading-text">Caricamento enti in corso...</span>
          </div>
        </div>

        <!-- Tabella enti -->
        <p-table
          [value]="entesFiltrati"
          [scrollable]="true"
          scrollHeight="400px"
          styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
          [loading]="caricamentoInCorso">

          <ng-template pTemplate="header">
            <tr>
              <th style="width: 60px;"></th>
              <th style="width: 60px;">Tipo</th>
              <th>Ente</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-ente let-rowIndex="rowIndex">
            <tr
              [ngClass]="{'ente-selezionato': isSelezionato(ente)}"
              (click)="toggleSelezioneEnte(ente)"
              class="ente-row">
              <td class="text-center">
                <p-checkbox
                  [binary]="true"
                  [ngModel]="isSelezionato(ente)"
                  (click)="$event.stopPropagation()"
                  (onChange)="toggleSelezioneEnte(ente)">
                </p-checkbox>
              </td>
              <td class="text-center">
                <span
                  class="material-symbols-outlined"
                  [style.color]="stiliService.getColoreIconaEnteEsecutore(ente)"
                  [pTooltip]="ente.categoria.descrizione"
                  tooltipPosition="top">
                  {{ stiliService.getMaterialIconEnteEsecutore(ente)}}
                </span>
              </td>
              <td>
                <div class="ente-info">
                  <span class="ente-nome">{{ ente.label }}</span>
                  <!-- <span class="ente-categoria">{{ ente.categoria.descrizione }}</span> -->
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr *ngIf="!caricamentoInCorso">
              <td colspan="3" class="text-center py-4">
                <div class="empty-message">
                  <i class="pi pi-search" style="font-size: 2rem; color: #ccc;"></i>
                  <p *ngIf="filtroEnte">Nessun ente trovato con i criteri di ricerca.</p>
                  <p *ngIf="!filtroEnte">Nessun ente disponibile.</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- Schermata di conferma -->
    <div class="confirm-screen" *ngIf="mostraConferma">
      <div class="confirm-content">
        <span class="material-icons" style="font-size: 48px; color: #4f97c4; margin-bottom: 1rem;">dashboard</span>
        <h3>Conferma generazione richieste</h3>
        <p>Stai per generare {{ entiSelezionati.length }} richieste per l'anno {{ anno + 1}}.</p>
        <p class="mb-4">Questa operazione non può essere annullata.</p>

        <p-divider></p-divider>

        <div class="confirm-enti-list" *ngIf="entiSelezionati.length <= 10">
          <h4>Enti selezionati:</h4>
          <ul>
            <li *ngFor="let ente of entiSelezionati">
              <span
                class="material-symbols-outlined"
                [style.color]="stiliService.getColoreIconaEnteEsecutore(ente)"
                style="vertical-align: middle; margin-right: 8px;">
                {{ stiliService.getMaterialIconEnteEsecutore(ente) }}
              </span>
              {{ ente.label }}
            </li>
          </ul>
        </div>

        <div class="confirm-enti-summary" *ngIf="entiSelezionati.length > 10">
          <h4>Riepilogo enti selezionati:</h4>
          <ul class="category-summary">
            <li *ngFor="let categoria of getCategorieSummary()">
              <span class="categoria-count">{{ categoria.count }}</span>
              {{ categoria.nome }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Footer del dialog -->
    <div class="dialog-footer" [ngClass]="{'confirm-footer': mostraConferma}">
      <ng-container *ngIf="!mostraConferma">
        <button
          pButton
          pRipple
          label="Annulla"
          icon="pi pi-times"
          class="p-button-outlined p-button-secondary"
          [disabled]="generazioneInCorso"
          (click)="onHide()">
        </button>
        <button
          pButton
          pRipple
          label="Prosegui"
          icon="pi pi-arrow-right"
          class="p-button-primary"
          [disabled]="entiSelezionati.length === 0 || generazioneInCorso"
          (click)="proseguiConGenerazione()">
        </button>
      </ng-container>

      <ng-container *ngIf="mostraConferma">
        <button
          pButton
          pRipple
          label="Torna alla selezione"
          icon="pi pi-arrow-left"
          class="p-button-outlined p-button-secondary"
          [disabled]="generazioneInCorso"
          (click)="annullaConferma()">
        </button>
        <button
          pButton
          pRipple
          label="Genera richieste"
          icon="pi pi-check"
          class="p-button-success"
          [loading]="generazioneInCorso"
          (click)="generaRichieste()">
        </button>
      </ng-container>
    </div>
  </div>
</p-dialog>

<!-- Toast per notifiche -->
<p-toast position="top-right"></p-toast>
